export { default as Home } from "./Home";
export { default as Men } from "./Men";
export { default as Women } from "./Women";
export { default as Kids } from "./Kids";
export { default as Product } from "./ProductDetail";
export { default as Cart } from "./Cart";
export { default as Account } from "./Account";
export { default as Contact } from "./Contact";
export { default as Search } from "./Search";
export { default as OrderStatus } from "./OrderStatus";
export { default as Checkout } from "./Checkout";
export { default as AllProduct } from "./AllProduct";
